/* ==========================================================================
   Custom Freight Notice — JS
   Project: Freight Messaging
   ========================================================================== */

(function () {
  'use strict';

  /* --------------------------------------------------------------------------
     Product Page — Badge accordion toggle
     -------------------------------------------------------------------------- */

  function initFreightBadge() {
    var badges = document.querySelectorAll('[data-freight-badge]');
    badges.forEach(function (badge) {
      var toggle = badge.querySelector('.custom-freight-badge__toggle');
      var details = badge.querySelector('.custom-freight-badge__details');
      if (!toggle || !details) return;

      function toggleBadge() {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        if (expanded) {
          details.classList.remove('is-open');
        } else {
          details.hidden = false;
          // Force reflow so the transition triggers
          details.offsetHeight; // eslint-disable-line no-unused-expressions
          details.classList.add('is-open');
        }
      }

      badge.addEventListener('click', toggleBadge);
    });
  }

  /* --------------------------------------------------------------------------
     Cart Page — Show/hide banner on dynamic cart updates
     -------------------------------------------------------------------------- */

  function initFreightCartBanner() {
    // Banner is rendered server-side by Liquid.
    // This JS handles dynamic cart updates (AJAX add/remove)
    // by checking the cart JSON for freight-quoted items.

    var banner = document.querySelector('[data-freight-cart-banner]');
    if (!banner) return;

    // Listen for theme cart events to refresh banner visibility
    document.addEventListener('on:line-item:change', refreshCartBanner);
    document.addEventListener('dispatch:cart-drawer:refresh', refreshCartBanner);
  }

  function refreshCartBanner() {
    fetch(theme.routes.cart_url + '.js', {
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var banner = document.querySelector('[data-freight-cart-banner]');
        if (!banner) return;

        var hasFreight = cart.items.some(function (item) {
          // Product tags are available on cart items as a comma-separated string
          return item.product_type === 'freight-quoted' ||
            (item.properties && item.properties._freight_quoted);
        });

        // Note: For server-rendered banner, we only hide it if no freight items remain.
        // We can't easily add it back via JS since it's a Liquid snippet.
        // A full page reload on cart change handles the re-show case.
        if (!hasFreight) {
          banner.style.display = 'none';
        }
      })
      .catch(function () {
        // Silently fail — banner stays in its current state
      });
  }

  /* --------------------------------------------------------------------------
     Shipping Calculator — Rewrite "Freight Pending: $0.01" into clear message
     -------------------------------------------------------------------------- */

  function initShippingCalculatorOverride() {
    // Wait for the shipping-calculator custom element to be defined
    customElements.whenDefined('shipping-calculator').then(function () {
      var calculators = document.querySelectorAll('shipping-calculator');
      calculators.forEach(function (calc) {
        var originalShowRates = calc.showRates;
        if (!originalShowRates) return;

        calc.showRates = function (data) {
          // Let the theme render rates normally first
          originalShowRates.call(this, data);

          var ratesEl = this.querySelector('.js-rates-text');
          if (!ratesEl) return;

          // Rewrite any standalone "Freight Pending" line items
          var items = ratesEl.querySelectorAll('li');
          items.forEach(function (li) {
            if (li.textContent.toLowerCase().indexOf('freight pending') !== -1) {
              li.textContent = 'Freight Shipping: Quoted separately \u2014 confirmed within 1 business day';
            }
          });

          // If cart has freight items, append a note below the rates
          var hasFreightInCart = !!document.querySelector('[data-freight-cart-banner]');
          var existingNote = ratesEl.querySelector('.custom-freight-rate-note');
          if (hasFreightInCart && !existingNote) {
            var note = document.createElement('p');
            note.className = 'custom-freight-rate-note';
            note.textContent = 'Freight items in your order will be quoted separately \u2014 we\u2019ll confirm within 1 business day.';
            ratesEl.appendChild(note);
          }
        };
      });
    });
  }

  /* --------------------------------------------------------------------------
     Cart Drawer — Checkout confirmation modal for freight-quoted items
     -------------------------------------------------------------------------- */

  function initFreightCheckoutModal() {
    // Intercept checkout form submission — show modal if freight items present.
    // All DOM lookups are fresh each time (cart drawer AJAX replaces innerHTML).
    // Uses form.submit() to bypass our own handler — no flag needed.

    document.addEventListener('submit', function (e) {
      if (e.target.id !== 'cart-drawer-form') return;

      var hasFreight = !!e.target.querySelector('[data-freight-in-cart]');
      if (!hasFreight) return;

      e.preventDefault();
      var modal = document.querySelector('[data-freight-checkout-modal]');
      if (modal) {
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        var proceedBtn = modal.querySelector('[data-freight-modal-proceed]');
        if (proceedBtn) proceedBtn.focus();
      }
    });

    function submitCheckout() {
      var form = document.getElementById('cart-drawer-form');
      if (!form) return;
      // Add hidden input with name="checkout" so Shopify routes to checkout
      // (replaces the submit button's name attribute in form data).
      // form.submit() does NOT fire the submit event, so it cleanly
      // bypasses our handler above — no flags, no re-entry.
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'checkout';
      input.value = '';
      form.appendChild(input);
      form.submit();
    }

    function closeModal() {
      var modal = document.querySelector('[data-freight-checkout-modal]');
      if (modal) modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // All dismiss paths proceed to checkout
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-freight-modal-proceed]') || e.target.closest('[data-freight-modal-close]')) {
        closeModal();
        submitCheckout();
      }
    });

    document.addEventListener('keydown', function (e) {
      var modal = document.querySelector('[data-freight-checkout-modal]');
      if (e.key === 'Escape' && modal && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
        submitCheckout();
      }
    });
  }

  /* --------------------------------------------------------------------------
     Init
     -------------------------------------------------------------------------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initFreightBadge();
    initFreightCartBanner();
    initShippingCalculatorOverride();
    initFreightCheckoutModal();
  }
})();
